import { Box, Drawer, Toolbar } from "@mui/material";
import SearchMenu from "../../../SearchMenu/SearchMenu";
import { DrawerProps } from "./DrawerButton";

export default function SearchDrawer({ open, handleClose }: DrawerProps) {
  return (
    <Drawer open={open} onClose={handleClose} anchor="top">
      <Toolbar />
      <Box sx={{ padding: "10px 8px 8px 8px" }}>
        <SearchMenu onSearch={async () => handleClose()} />
      </Box>
    </Drawer>
  );
}
